import React from 'react';
import BucketBalance from '../../../../generic-components/BucketBalance';
import { TAX_BUCKET_BALANCE } from '../../constants';
import { useStore } from '../../../../store';

const TaxBucketBalance = () => {
  const { HEADER } = TAX_BUCKET_BALANCE;
  const summary = useStore(state => state.summary);
  const { getPrimaryAccount } = useStore(state => state);
  const getTaxBucketBalance = () => {
    if (summary && summary.taxBucketBalance && typeof summary.taxBucketBalance.balance === 'number' && summary.emergencyBucketResponse.balance >= 0) {
      if (`${summary.taxBucketBalance.balance}`.indexOf('.') !== -1 && (`${summary.taxBucketBalance.balance}`.length - `${summary.taxBucketBalance.balance}`.indexOf('.') === 2)) {
        return `$${summary.taxBucketBalance.balance}0`;
      }
      return `$${summary.taxBucketBalance.balance}${Number.isInteger(summary.taxBucketBalance.balance) ? '.00' : ''}`;
    }
    return '$0.00';
  };

  const isAddButtonDisabled = () => {
    if (getPrimaryAccount().balance) {
      return getPrimaryAccount().balance <= 0;
    }
    return true;
  };
  const isWithdrawButtonDisabled = () => {
    if (summary && summary.taxBucketBalance && typeof summary.taxBucketBalance.balance === 'number') {
      return summary.taxBucketBalance.balance <= 0;
    }
    return true;
  };

  return (
    <BucketBalance
      addButtonDisabled={isAddButtonDisabled()}
      withdrawButtonDisabled={isWithdrawButtonDisabled()}
      addButtonPath='/tax-bucket-add-money'
      withdrawButtonPath='/tax-bucket-withdraw-money'
      bucketBalance={getTaxBucketBalance()}
      bucketName={HEADER}
    />
  );
};

export default TaxBucketBalance;
